var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["online-count", { "online-count--absolute": _vm.isAbsolute }] },
    [
      _c("div", { staticClass: "online-count__dot" }),
      _c("span", { staticClass: "online-count__number" }, [
        _vm._v(_vm._s(_vm.count)),
      ]),
      _c("span", { staticClass: "online-count__label" }, [_vm._v("Online")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }